import React, { Component } from 'react';
import { Button, Segment, Form, Input, Select, Checkbox, Grid, Message } from 'semantic-ui-react'

const options = [
  { key: 'm', text: 'Male', value: 'Male' },
  { key: 'f', text: 'Female', value: 'Female' },
  { key: 'o', text: 'Other', value: 'Other' },
]

export class EnrollmentPersonalInformation extends Component {
  state = {
    haveErrors: false,
    message: '',
    error: {
      firstName: false,
      lastName: false,
      birthDate: false,
      gender: false,
      religion: false,
      placeOfBirth: false,
    },
  }

  continue = e => {
    e.preventDefault();
    if(this.handleValidation()) {
      this.setState({haveErrors: false})
      this.props.nextStep();
    } else {
      this.setState({haveErrors: true, message: 'Required fields must not be blank.'})
    }
  };

  handleValidation = () => {
    let hasValidationErrors = false;
    const { values } = this.props;
    const { error } = this.state;
    if(values.firstName === '') {
      error.firstName = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.firstName = false;
      this.setState({
        error
      })
    }

    if(values.lastName === '') {
      error.lastName = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.lastName = false;
      this.setState({
        error
      })
    }

    if(values.birthDate === '') {
      error.birthDate = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.birthDate = false;
      this.setState({
        error
      })
    }

    if(values.gender === '') {
      error.gender = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.gender = false;
      this.setState({
        error
      })
    }

    if(values.religion === '') {
      error.religion = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.religion = false;
      this.setState({
        error
      })
    }

    if(values.placeOfBirth === '') {
      error.placeOfBirth = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.placeOfBirth = false;
      this.setState({
        error
      })
    }

    if (hasValidationErrors) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { values, handleChange } = this.props;
    return (
      <Segment className='enrollment-form-segment'>
        <h1>Personal Information</h1>
        {
          this.state.haveErrors &&
          <Message
            error
            content={this.state.message}
          />
        }
        <Form error={this.state.haveErrors}>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.firstName} control={Input} value={values.firstName} name='firstName' label='First name' placeholder='First name' onChange={handleChange}/>
            <Form.Field control={Input} value={values.middleName} name='middleName' label='Middle name' placeholder='Middle name' onChange={handleChange}/>
            <Form.Field required error={this.state.error.lastName} control={Input} value={values.lastName} name='lastName' label='Last name' placeholder='Last name' onChange={handleChange}/>
            <Form.Field control={Input} value={values.extensionName} name='extensionName' label='Extension name' placeholder='Extension name' onChange={handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={values.nickName} name='nickName' label='Nickname' placeholder='Nickname' onChange={handleChange}/>
            <Form.Field control={Input} value={values.lrn} name='lrn' label='LRN' placeholder='LRN' onChange={handleChange}/>
            <Form.Field required error={this.state.error.birthDate}>
              <label>Birthdate</label>
              <Input required value={values.birthDate} name='birthDate' type='date' placeholder='Birthdate' onChange={handleChange}/>
            </Form.Field>
          </Form.Group>

          <Form.Group widths='equal'>

            <Form.Field required error={this.state.error.gender} value={values.gender} name='gender' control={Select} label='Gender' options={options} placeholder='Gender' onChange={handleChange}/>
            <Form.Field required error={this.state.error.religion} control={Input} value={values.religion} name='religion' label='Religion' placeholder='Religion' onChange={handleChange}/>
            <Form.Field required error={this.state.error.placeOfBirth} control={Input} value={values.placeOfBirth} name='placeOfBirth' label='Place Of Birth' placeholder='Place Of Birth' onChange={handleChange}/>

          </Form.Group>

          <h4> Medical History </h4>
          <Form.Group widths='equal'>
            <Form.Field control={Checkbox} checked={values.beenHospitalized} name='beenHospitalized' label='Have Been Hospitalized' onChange={this.props.toggleHospitalized}/>
            <Form.Field control={Input} value={values.hospitalReason} name='hospitalReason' label='Reason' placeholder='Reason' onChange={handleChange}/>
            <Form.Field control={Input} value={values.medicalHistory} name='medicalHistory' label='Medical History' placeholder='Medical History' onChange={handleChange}/>

          </Form.Group>

        </Form>
        <Grid>
          <Grid.Column width={8}>

          </Grid.Column>
          <Grid.Column width={8} textAlign='right'>
            <Button onClick={this.continue}>Continue</Button>
          </Grid.Column>
        </Grid>

      </Segment>
    );
  }
}

export default EnrollmentPersonalInformation;
